import { c as _c } from "react/compiler-runtime";
import type { WebMainInfoResponse } from '@module/apis/client-side/main/type';
import { mainQueryKeys } from '@module/queries/main/mainQueryKeys';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { buildUpdatedSidePickList } from './sidePickList.policy';
function useSetSidePickListQueryData() {
  const $ = _c(8);
  const queryClient = useQueryClient();
  const playInfo = useFetchLivePlayMutationStore(_temp);
  const status = useFetchLivePlayMutationStore(_temp2);
  const isPlayInfoLoading = status === "pending";
  let t0;
  if ($[0] !== isPlayInfoLoading || $[1] !== playInfo || $[2] !== queryClient) {
    t0 = () => {
      if (!playInfo?.media || isPlayInfoLoading) {
        return;
      }
      queryClient.setQueriesData({
        queryKey: mainQueryKeys.fetchWebMainInfo._def,
        exact: false
      }, prev => {
        if (!prev) {
          return prev;
        }
        return {
          ...prev,
          pick: buildUpdatedSidePickList(prev.pick, playInfo.media)
        };
      });
    };
    $[0] = isPlayInfoLoading;
    $[1] = playInfo;
    $[2] = queryClient;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = playInfo?.media;
  let t2;
  if ($[4] !== isPlayInfoLoading || $[5] !== queryClient || $[6] !== t1) {
    t2 = [t1, isPlayInfoLoading, queryClient];
    $[4] = isPlayInfoLoading;
    $[5] = queryClient;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t0, t2);
}
function _temp2(state_0) {
  return state_0.status;
}
function _temp(state) {
  return state.data;
}
export default useSetSidePickListQueryData;